import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import axios from 'axios';
import swal from 'sweetalert2';
import { useNavigate, useParams } from 'react-router-dom';
import { Select, TimePicker } from "antd";
import dayjs from "dayjs";

const EditZoomMeeting = () => {

    const { meetingId } = useParams();

    const [formData, setFormData] = useState({
        topic: "",
        start_date: "",
        start_time: "",
        duration: "",
        recurrence_type: "",
        weekly_days: [],
        end_date: ""
    });
    const [originalStartDateTime, setOriginalStartDateTime] = useState(null);

    const navigate = useNavigate();

    /* -------------------- FETCH MEETING DETAILS -------------------- */
    useEffect(() => {
        fetchMeetingDetails(meetingId);
    }, [meetingId]);

    const fetchMeetingDetails = async (meetingId) => {
        try {
            const res = await axios.get(`/api/v1/adm/zoom/meeting/${meetingId}`);
            const meeting = res.data?.data;

            const startDateTime = meeting?.start_time
                ? dayjs(meeting.start_time)
                : null;

            setOriginalStartDateTime(startDateTime);

            setFormData({
                topic: meeting?.topic || "",

                // YYYY-MM-DD
                start_date: meeting?.start_time
                    ? dayjs(meeting.start_time).format("YYYY-MM-DD")
                    : "",

                // hh:mm AM/PM
                start_time: meeting?.start_time
                    ? dayjs(meeting.start_time).format("hh:mm A")
                    : "",

                duration: meeting?.duration || "",

                // daily → 1, weekly → 2
                recurrence_type:
                    meeting?.recurrence_type === "daily"
                        ? 1
                        : meeting?.recurrence_type === "weekly"
                            ? 2
                            : "",

                // "" → []
                weekly_days: meeting?.weekly_days
                    ? meeting?.weekly_days?.split(",").map(Number)
                    : [],

                // YYYY-MM-DD
                end_date: meeting?.end_date
                    ? dayjs(meeting.end_date).format("YYYY-MM-DD")
                    : ""
            });

        } catch (error) {
            console.error(error);
            swal.fire("Error!", "Failed to load meeting data", "error");
        }
    };

    /* -------------------- HANDLERS -------------------- */

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleWeekDaysChange = (values) => {
        setFormData(prev => ({
            ...prev,
            weekly_days: values.map(Number)
        }));
    };

    const handleTimeChange = (time) => {
        setFormData(prev => ({
            ...prev,
            start_time: time ? dayjs(time).format("hh:mm A") : ""
        }));
    };

    /* -------------------- SUBMIT UPDATE -------------------- */

    const handleSubmit = async (e) => {
        e.preventDefault();

        const startDateTime = dayjs(
            `${formData.start_date} ${formData.start_time}`,
            "YYYY-MM-DD hh:mm A"
        );

        // If user modified start date/time → must be future
        if (
            originalStartDateTime &&
            !startDateTime.isSame(originalStartDateTime) &&
            startDateTime.isBefore(dayjs())
        ) {
            swal.fire(
                "Invalid Start Time",
                "Start date & time must be in the future.",
                "warning"
            );
            return;
        }

        // End date validation
        const minEndDate = dayjs(formData.start_date).add(7, "day");

        if (dayjs(formData.end_date).isBefore(minEndDate)) {
            swal.fire(
                "Invalid End Date",
                "End date must be at least 7 days after start date.",
                "warning"
            );
            return;
        }

        const payload = {
            topic: formData.topic,
            start_date: formData.start_date,
            start_time: formData.start_time,
            duration: Number(formData.duration),
            recurrence_type: Number(formData.recurrence_type),
            weekly_days: formData.weekly_days,
            end_date: formData.end_date
        };

        try {
            await axios.put(`/api/v1/adm/zoom/meeting/${meetingId}`, payload);

            swal.fire("Success!", "Zoom meeting updated successfully.", "success");
            navigate("/zoom-meetings");

        } catch (error) {
            console.error(error);
            swal.fire("Error!", "Update failed", "error");
        }
    };

    const options = [
        { label: "Sunday", value: 1 },
        { label: "Monday", value: 2 },
        { label: "Tuesday", value: 3 },
        { label: "Wednesday", value: 4 },
        { label: "Thursday", value: 5 },
        { label: "Friday", value: 6 },
        { label: "Saturday", value: 7 }
    ];

    const handleGoBack = () => {
        window.history.back()
    };

    console.log('weekly_days', formData?.weekly_days)

    return (
        <Layout>
            <div className='page-content'>
                <div className="container">
                    <div className="card p-5">
                        <div className='d-flex'>
                            <div className='col-md-6 col-lg-6 text-start'><h5>Update Meeting</h5></div>
                            <div className='col-md-6 col-lg-6 text-end'><button className='btn btn-primary' onClick={handleGoBack}> Back</button></div>
                        </div>
                        <span id="student_message" />
                        <br />
                        <form onSubmit={handleSubmit}>
                            <div className="row g-4">

                                <div className="col-md-6">
                                    <label className="form-label">Topic *</label>
                                    <input
                                        type="text"
                                        name="topic"
                                        className="form-control"
                                        value={formData.topic}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Start Date *</label>
                                    <input
                                        type="date"
                                        name="start_date"
                                        className="form-control"
                                        value={formData.start_date}
                                        min={
                                            originalStartDateTime
                                                ? dayjs(originalStartDateTime).isBefore(dayjs(), "day")
                                                    ? formData.start_date // allow existing past date
                                                    : dayjs().format("YYYY-MM-DD")
                                                : dayjs().format("YYYY-MM-DD")
                                        }
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Start Time *</label>
                                    <TimePicker
                                        use12Hours
                                        format="hh:mm A"
                                        className="w-100"
                                        value={formData.start_time ? dayjs(formData.start_time, "hh:mm A") : null}
                                        onChange={handleTimeChange}
                                        disabledTime={() => {
                                            const selectedDate = dayjs(formData.start_date);
                                            const today = dayjs();

                                            // If editing past meeting → allow full time range
                                            if (
                                                originalStartDateTime &&
                                                originalStartDateTime.isBefore(today)
                                            ) {
                                                return {};
                                            }

                                            // If start date is today → block past time
                                            if (selectedDate.isSame(today, "day")) {
                                                return {
                                                    disabledHours: () =>
                                                        Array.from({ length: today.hour() }, (_, i) => i),
                                                    disabledMinutes: (hour) =>
                                                        hour === today.hour()
                                                            ? Array.from({ length: today.minute() }, (_, i) => i)
                                                            : [],
                                                };
                                            }

                                            return {};
                                        }}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Duration (minutes) *</label>
                                    <input
                                        type="number"
                                        name="duration"
                                        className="form-control"
                                        value={formData.duration}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Recurrence Type *</label>
                                    <select
                                        name="recurrence_type"
                                        className="form-select"
                                        value={formData.recurrence_type}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select</option>
                                        <option value={1}>Daily</option>
                                        <option value={2}>Weekly</option>
                                    </select>
                                </div>

                                {formData.recurrence_type == 2 && (
                                    <div className="col-md-6">
                                        <label className="form-label">Week Days *</label>
                                        <Select
                                            mode="multiple"
                                            options={options}
                                            value={formData.weekly_days}
                                            onChange={handleWeekDaysChange}
                                            style={{ width: "100%" }}
                                            placeholder="Select week days"
                                            className="zoom-multi-select"
                                        />
                                    </div>
                                )}

                                <div className="col-md-6">
                                    <label className="form-label">End Date *</label>
                                    <input
                                        type="date"
                                        name="end_date"
                                        className="form-control"
                                        value={formData.end_date}
                                        min={
                                            formData.start_date
                                                ? dayjs(formData.start_date).add(7, "day").format("YYYY-MM-DD")
                                                : ""
                                        }
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-12 mt-4">
                                    <button type="submit" className="btn btn-primary">
                                        Update
                                    </button>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default EditZoomMeeting;
